import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { API } from "@/App";
import axios from "axios";
import { Mail, ArrowLeft, CheckCircle } from "lucide-react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-4">
        <div className="text-center max-w-md">
          <CheckCircle className="h-12 w-12 mx-auto text-green-500 mb-4" />
          <h1 className="text-xl font-heading font-bold mb-2">Check Your Email</h1>
          <p className="text-muted-foreground mb-6">
            If an account exists for <strong>{email}</strong>, we've sent a password reset link. Check your inbox and spam folder.
          </p>
          <Link to="/">
            <Button variant="outline" className="rounded-full" data-testid="back-to-login-btn">
              <ArrowLeft className="mr-2 h-4 w-4" /> Back to Sign In
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/thrively-logo.png" alt="Thrively" className="h-16 w-auto mx-auto mb-4" />
          <h1 className="text-2xl font-heading font-bold">Forgot Password?</h1>
          <p className="text-muted-foreground mt-1">Enter your email and we'll send you a reset link</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4 bg-white rounded-3xl shadow-lg p-8">
          <div className="space-y-2">
            <Label>Email Address</Label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              className="rounded-xl"
              data-testid="forgot-email-input"
            />
          </div>
          <Button type="submit" className="w-full rounded-full h-12 mt-4" disabled={loading} data-testid="send-reset-btn">
            <Mail className="mr-2 h-4 w-4" />
            {loading ? "Sending..." : "Send Reset Link"}
          </Button>
        </form>
        <div className="text-center mt-4">
          <Link to="/" className="text-sm text-primary hover:underline">Back to Sign In</Link>
        </div>
      </div>
    </div>
  );
}
